<template>

  <b-row >
    <b-col class="shader"   id="services" >
      <b-row cols-lg="frame">

        <div class="">
          <div class="scroll__stage">
            <div class="scroll__content">

              <section class="section" >
                <div class="section__title">
                  <h1 class="section__title-number"  >01</h1>
                  <h2 class="section__title-text">Exchange</h2>
                  <p class="section__title-arrow">
                    <span>➤</span><br>
                    <span>➤</span>
                  </p>
                </div>
                <div class="section__paragraph">
                  UNFXCOIN, Your premier crypto currency exchange, offering top-notch P2P, OTC, and trade services with a focus on security and excellence.
                  <br>
                  <br>

                  <a href="https://unfxcoin.com" target="_blank" style="width: 350px;margin-top: 42px">
                    <div   style="width: 100%" >
                      <div class="rect-button">
                        <div     class="rect-button text-light bg-accent-custom bg-primary-custom" >
                          <span class="nexaExtraBold"> open app  </span>
                        </div>
                      </div>

                    </div>
                  </a>

                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                </div>

              </section>
              <section class="section">
                <div class="section__title">
                  <h1 class="section__title-number">02</h1>
                  <h2 class="section__title-text">Wallet custody</h2>
                </div>
                <p class="section__paragraph">
                  UNFXBIT ensures the security of your crypto currency transactions and gives you full control over your assets, eliminating the need for third-party reliance or trust

                  <br>
                  <br>
                  <a href="https://app.unfxbit.com" target="_blank" style="width: 350px;margin-top: 42px">
                    <div   style="width: 100%" >
                      <div class="rect-button">
                        <div     class="rect-button text-light bg-accent-custom bg-primary-custom" >
                          <span class="nexaExtraBold"> open app  </span>
                        </div>
                      </div>

                    </div>
                  </a>

                  <br>
                  <br>
                  <br>
                  <br>
                </p>
              </section>
              <section class="section">
                <div class="section__title">
                  <h1 class="section__title-number">03</h1>
                  <h2 class="section__title-text" >Explorer</h2>
                </div>
                <p class="section__paragraph">
                  Our <b>All in one</b> crypto explorer lets you enter a transaction ID or crypto address to quickly find all the details in one place, making it simple to track and manage your cryptocurrency activity.

                  <br>
                  <br>
                  <a href="https://explorer.unfxbit.com" target="_blank" style="width: 350px;margin-top: 42px">
                    <div   style="width: 100%" >
                      <div class="rect-button">
                        <div     class="rect-button text-light bg-accent-custom bg-primary-custom" >
                          <span class="nexaExtraBold"> open app  </span>
                        </div>
                      </div>

                    </div>
                  </a>

                  <br>
                  <br>
                  <br>

                </p>
              </section>

              <section class="section">
                <div class="section__title">
                  <h1 class="section__title-number">04</h1>
                  <h2 class="section__title-text" >Node View</h2>
                </div>
                <p class="section__paragraph">

                  You'll save money on setting up blockchain computers and effortlessly access the entire blockchain world using 'NodeView: Your Entry to the Blockchain World,' a simple tool that lets you connect to all networks through a single API.
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <a href="#"  style="z-index: 999;display: none" class="section__button" >See more</a>
                </p>
              </section>
            </div>
          </div>
          <div class="layout__line" ></div>
        </div>
      </b-row>

      <b-col  id="servicesEnd" ></b-col>
    </b-col>
  </b-row>
</template>



<script>


import * as THREE from 'three'
import GSAP from 'gsap'

import Animations from '../assets/js/shaders/Animations'
import SmoothScroll from '../assets/js/shaders/SmoothScroll'


class Shader   {
  constructor() {
    this.element = document.querySelector('.scroll__stage')
    /*
            this.scrollListener = function () {
                if (!this.scroll.running) {
                    window.requestAnimationFrame(this.updateScrollAnimations)

                    this.scroll.running = true
                }
            };*/
    this.elements = {
      // line: this.element.querySelector('.layout__line')
    }

    this.viewport = {
      width: window.innerWidth,
      height: window.innerHeight,
    }

    this.mouse = {
      x: 0,
      y: 0
    }

    this.scroll = {
      height: 0,
      limit: 0,
      hard: 0,
      soft: 0,
      ease: 0.05,
      normalized: 0,
      running: false
    }

    this.settings = {
      // vertex
      uFrequency: {
        start: 0,
        end: 4
      },
      uAmplitude: {
        start: 4,
        end: 4
      },
      uDensity: {
        start: 1,
        end: 1
      },
      uStrength: {
        start: 0,
        end: 1.1
      },
      // fragment
      uDeepPurple: {  // max 1
        start: 1,
        end: 0
      },
      uOpacity: {  // max 1
        start: .1,
        end: .66
      }
    }

    this.scene = new THREE.Scene()

    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true
    })

    this.canvas = this.renderer.domElement

    this.camera = new THREE.PerspectiveCamera(
        75,
        this.viewport.width / this.viewport.height,
        .1,
        10
    )

    this.clock = new THREE.Clock()

    this.smoothScroll = new SmoothScroll({
      element: this.element,
      viewport: this.viewport,
      scroll: this.scroll
    })

    GSAP.defaults({
      ease: 'power2',
      duration: 6.6,
      overwrite: true
    })

    this.updateScrollAnimations = this.updateScrollAnimations.bind(this)
    this.update = this.update.bind(this)


    //TODO Shader commented
    this.init()
  }

  init() {
    this.addCanvas()
    this.addCamera()
    this.addMesh()
    this.addEventListeners()
    this.onResize()
    this.update()
  }

  /**
   * STAGE
   */
  addCanvas() {
    this.renderer.domElement.classList.add('webgl')


    Object.assign(this.renderer.domElement.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
      background: 'transparent',
      'z-index': 0,
    })


    this.renderer.domElement.id = 'shader3d'

    document.getElementById('shaderBox').appendChild(this.renderer.domElement)

    document.getElementById("shaderBox").style.visibility =  'hidden'
    document.getElementById("shaderBox").style.display =  'none'
    // document.getElementById('shaderBox').classList.add('d-none')


    /*document.getElementById('shader3d').appendChild(this.canvas)
    document.getElementById('shader3d').classList.add('d-none')*/
  }


  addCamera() {
    this.camera.position.set(0, 0, 2.5)
    this.scene.add(this.camera)
  }

  /**
   * OBJECT
   */
  addMesh() {
    this.geometry = new THREE.IcosahedronGeometry(1, 64)


    this.material = new THREE.ShaderMaterial({
      wireframe: true,
      blending: THREE.AdditiveBlending,
      transparent: true,
      uniforms: {
        uFrequency: {value: this.settings.uFrequency.start},
        uAmplitude: {value: this.settings.uAmplitude.start},
        uDensity: {value: this.settings.uDensity.start},
        uStrength: {value: this.settings.uStrength.start},
        uDeepPurple: {value: this.settings.uDeepPurple.start},
        uOpacity: {value: this.settings.uOpacity.start}
      }
    })

    this.material.onBeforeCompile = shader => {


      const hp = '#define GLSLIFY 1\n// GLSL textureless classic 3D noise "cnoise",\n// with an RSL-style periodic variant "pnoise".\n// Author:  Stefan Gustavson (stefan.gustavson@liu.se)\n// Version: 2011-10-11\n//\n// Many thanks to Ian McEwan of Ashima Arts for the\n// ideas for permutation and gradient selection.\n//\n// Copyright (c) 2011 Stefan Gustavson. All rights reserved.\n// Distributed under the MIT license. See LICENSE file.\n// https://github.com/ashima/webgl-noise\n//\nvec3 mod289(vec3 x)\n{\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289(vec4 x)\n{\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute(vec4 x)\n{\n  return mod289(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt(vec4 r)\n{\n  return 1.79284291400159 - 0.85373472095314 * r;\n}\n\nvec3 fade(vec3 t) {\n  return t*t*t*(t*(t*6.0-15.0)+10.0);\n}\n\n// Classic Perlin noise, periodic variant\nfloat pnoise(vec3 P, vec3 rep)\n{\n  vec3 Pi0 = mod(floor(P), rep); // Integer part, modulo period\n  vec3 Pi1 = mod(Pi0 + vec3(1.0), rep); // Integer part + 1, mod period\n  Pi0 = mod289(Pi0);\n  Pi1 = mod289(Pi1);\n  vec3 Pf0 = fract(P); // Fractional part for interpolation\n  vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0\n  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);\n  vec4 iy = vec4(Pi0.yy, Pi1.yy);\n  vec4 iz0 = Pi0.zzzz;\n  vec4 iz1 = Pi1.zzzz;\n\n  vec4 ixy = permute(permute(ix) + iy);\n  vec4 ixy0 = permute(ixy + iz0);\n  vec4 ixy1 = permute(ixy + iz1);\n\n  vec4 gx0 = ixy0 * (1.0 / 7.0);\n  vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;\n  gx0 = fract(gx0);\n  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);\n  vec4 sz0 = step(gz0, vec4(0.0));\n  gx0 -= sz0 * (step(0.0, gx0) - 0.5);\n  gy0 -= sz0 * (step(0.0, gy0) - 0.5);\n\n  vec4 gx1 = ixy1 * (1.0 / 7.0);\n  vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;\n  gx1 = fract(gx1);\n  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);\n  vec4 sz1 = step(gz1, vec4(0.0));\n  gx1 -= sz1 * (step(0.0, gx1) - 0.5);\n  gy1 -= sz1 * (step(0.0, gy1) - 0.5);\n\n  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);\n  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);\n  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);\n  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);\n  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);\n  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);\n  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);\n  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);\n\n  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));\n  g000 *= norm0.x;\n  g010 *= norm0.y;\n  g100 *= norm0.z;\n  g110 *= norm0.w;\n  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));\n  g001 *= norm1.x;\n  g011 *= norm1.y;\n  g101 *= norm1.z;\n  g111 *= norm1.w;\n\n  float n000 = dot(g000, Pf0);\n  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));\n  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));\n  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));\n  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));\n  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));\n  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));\n  float n111 = dot(g111, Pf1);\n\n  vec3 fade_xyz = fade(Pf0);\n  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);\n  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);\n  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x);\n  return 2.2 * n_xyz;\n}\n\n// https://github.com/dmnsgn/glsl-rotate\nmat3 rotation3dY(float angle) {\n    float s = sin(angle);\n    float c = cos(angle);\n\n    return mat3(\n      c, 0.0, -s,\n      0.0, 1.0, 0.0,\n      s, 0.0, c\n    );\n  }\n  \nvec3 rotateY(vec3 v, float angle) {\n  return rotation3dY(angle) * v;\n}\n\n//\n\nuniform float uFrequency;\nuniform float uAmplitude;\nuniform float uDensity;\nuniform float uStrength;\n\nvarying float vDistortion;\n\nvoid main() {  \n  float distortion = pnoise(normal * uDensity, vec3(10.)) * uStrength;\n\n  vec3 pos = position + (normal * distortion);\n  float angle = sin(uv.y * uFrequency) * uAmplitude;\n  pos = rotateY(pos, angle);    \n    \n  vDistortion = distortion;\n\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.);\n}\n'
      const up = "#define GLSLIFY 1\nuniform float uOpacity;\nuniform float uDeepPurple;\n \nvarying float vDistortion;\n\nvec3 cosPalette(float t, vec3 a, vec3 b, vec3 c, vec3 d) {\n  return a + b * cos(6.28318 * (c * t + d));\n  \n}     \n \nvoid main() {\n  float distort = vDistortion * 3.;\n\n  vec3 brightness = vec3(.1, .1, .9);\n  vec3 contrast = vec3(.3, .3, .3);\n  vec3 oscilation = vec3(.5, .5, .9);\n  vec3 phase = vec3(.9, .1, .8);\n \n  vec3 color = cosPalette(distort, brightness, contrast, oscilation, phase);\n  \n  gl_FragColor = vec4(color, vDistortion);\n  gl_FragColor += vec4(min(uDeepPurple, 1.), 0., .5, min(uOpacity, 1.));\n}\n"


      shader.vertexShader = hp
      shader.fragmentShader = up
    }

    this.mesh = new THREE.Mesh(this.geometry, this.material)

    this.scene.add(this.mesh)
  }

  /**
   * SCROLL BASED ANIMATIONS
   */
  updateScrollAnimations() {
    this.scroll.running = false
    this.scroll.normalized = (this.scroll.hard / this.scroll.limit).toFixed(1)


    GSAP.to(this.mesh.rotation, {
      x: this.scroll.normalized * Math.PI
    })

    /* GSAP.to(this.elements.line, {
         scaleX: this.scroll.normalized,
         transformOrigin: 'left',
         duration: 1.5,
         ease: 'ease'
     }) */

    for (const key in this.settings) {
      if (this.settings[key].start !== this.settings[key].end) {
        GSAP.to(this.mesh.material.uniforms[key], {
          value: this.settings[key].start + this.scroll.normalized * (this.settings[key].end - this.settings[key].start)
        })
      }
    }
  }

  /**
   * EVENTS
   */
  addEventListeners() {
    window.addEventListener('load', this.onLoad.bind(this))

    //window.addEventListener('mousemove', this.onMouseMove.bind(this))  // enable for soundcheck (→ console)
    //  window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize.bind(this))
  }

  onLoad() {

    this.animations = new Animations(this.element, this.camera)
  }

  onMouseMove(event) {
    // if(document.getElementById("shaderBox").style.visibility  === 'visible') {
    this.mouse.x = (event.clientX / this.viewport.width).toFixed(2) * 4
    this.mouse.y = (event.clientY / this.viewport.height).toFixed(2) * 2

    GSAP.to(this.mesh.material.uniforms.uFrequency, {value: this.mouse.x})
    GSAP.to(this.mesh.material.uniforms.uAmplitude, {value: this.mouse.x})
    GSAP.to(this.mesh.material.uniforms.uDensity, {value: this.mouse.y})
    GSAP.to(this.mesh.material.uniforms.uStrength, {value: this.mouse.y})
    GSAP.to(this.mesh.material.uniforms.uDeepPurple, {value: this.mouse.x})
    GSAP.to(this.mesh.material.uniforms.uOpacity, {value: this.mouse.y})
    // }


  }

  onScroll() {

    if (!this.scroll.running) {
      window.requestAnimationFrame(this.updateScrollAnimations)

      this.scroll.running = true
    }
  }

  onResize() {
    this.viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    this.smoothScroll.onResize()

    if (this.viewport.width < this.viewport.height) {
      this.mesh.scale.set(.75, .75, .75)
    } else {
      this.mesh.scale.set(1, 1, 1)
    }

    this.camera.aspect = this.viewport.width / this.viewport.height
    this.camera.updateProjectionMatrix()

    this.renderer.setSize(this.viewport.width, this.viewport.height)
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5))
  }

  /**
   * LOOP
   */
  update() {
    const elapsedTime = this.clock.getElapsedTime()
    this.mesh.rotation.y = elapsedTime * .05

    this.smoothScroll.update()

     this.render()

    window.requestAnimationFrame(this.update)
  }

  /**
   * RENDER
   */
  render() {
    this.renderer.render(this.scene, this.camera)
  }

}
export default {
  name: 'Shader',
  components: {

  },
  created() {





  },
  mounted() {

    setTimeout(() => {
      this.shader = new Shader()
    },500);



    this.$root.$on('onScroll', (status) => {

      if(this.shader)
        this.shader.onScroll(status)
    });

  },
  destroyed() {

  },

  data() {
    return {

      shader: null

    };
  },
  methods: {

    scrollTo(id) {
      console.log(id)
      setTimeout(() => {
        global.scrollTo(id)
      }, 100);

    },
  },
}
</script>

<style>



</style>
